import $ from 'jquery';

export default ['BaseUtils', 'LocaleService', '$q', function (BaseUtils, LocaleService, $q) {
    var twitterApi = $q.defer();
    var twitterApiPromise = twitterApi.promise;

    $.getScript('https://platform.twitter.com/widgets.js').then(function () {
        /* globals twttr */
        twitterApi.resolve(twttr);
    }).fail(function (error) {
        console.error('Failed to load twitter due to', error.stack ? error.stack : error);
        twitterApi.reject(error);
    });

    return {
        restrict: 'E',

        link: function link(scope, element) {
            BaseUtils.assert.stringKey(scope, 'widgetID', 'Widget id should be specified. Create a widget at https://twitter.com/settings/widgets');

            twitterApiPromise.then(function (t) {
                t.widgets.createTimeline(scope.widgetID, element[0], {
                    lang: LocaleService.getCurrentLanguage(),
                    tweetLimit: Number(scope.tweetLimit) || undefined,
                    linkColor: scope.linkColor || undefined
                });
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/mediasidebar/directives/TwitterDirective.js
// module id = 1995
// module chunks = 0